import React from 'react';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, DotGroup } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import styled from "styled-components";

const Wrapper = styled.div`
  .controls {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;

    .btn-arrow {
      border: none;
      background: none;
      padding: 11px 20px;
    }

    .reverse-arrow {
      transform: rotateY(180deg);
    }

    .dot-group {
      display: flex;
      align-items: center;
      justify-content: center;

      .carousel__dot {
        width: 8px;
        height: 8px;
        border: none;
        border-radius: 50%;
        margin: 0 4px;
        padding: 0;
        background-color: #c3c4ca;
      }

      .carousel__dot--selected {
        width: 16px;
        height: 8px;
        border-radius: 10px;
        background-color: #E49680;
        transition: background 0.4s ease;
      }
    }
  }
`;

const DetailsEvent = ({ event, onBack }) => (
  <div>
    <button onClick={onBack} className="mb-4 p-2 bg-primary text-white rounded">
      ← Retour aux événements
    </button>
    <h2 className="text-xl font-bold mb-2">{event.title}</h2>
    <p>{event.description}</p>
    {/* ...autres infos (dates, créateur, etc.) */}
    {event.files && event.files.length > 0 && (
      <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={60}
        visibleSlides={1}
        totalSlides={event.files.length}
      >
        <Slider>
          {event.files.map((file, idx) => (
            <Slide index={idx} key={idx}>
              {file.typeMedia === "image" ? (
                <a href={file.url} target="_blank" className="block">
                  <img
                    src={file.url}
                    alt={file.name}
                    className="mx-auto w-3/4 md:w-1/2 h-auto rounded shadow"
                    style={{ }}
                  />
                </a>
              ) : (
                <a href={file.url} target="_blank" rel="noopener noreferrer" className="block text-center">
                  <div className="flex flex-col items-center">
                    <embed
                      src={file.url + "#page=1&zoom=40"}
                      type="application/pdf"
                      className="mx-auto w-3/4 md:w-2/3 lg:w-3/4 xl:w-4/5 rounded shadow"
                      style={{ 
                        border: "1px solid #ccc", 
                        borderRadius: "8px",
                        minHeight: "500px",
                        maxHeight: "700px"
                      }}
                    />
                    <p className="text-blue-600 text-center mt-2">Afficher le PDF</p>
                  </div>
                </a>
              )}
            </Slide>
          ))}
        </Slider>
        <Wrapper>
          <div className="controls">
            <ButtonBack className="btn-arrow ">
              <p className='text-cyan-600'>Précédent</p>
            </ButtonBack>
            <DotGroup className="dot-group" />
            <ButtonNext className="btn-arrow">
              <p className='text-cyan-600'>Suivant</p>
            </ButtonNext>
          </div>
        </Wrapper>
      </CarouselProvider>
    )}
  </div>
);

export default DetailsEvent;